import React from 'react';
import { Button } from '../ui/Button';
import { Check } from 'lucide-react';
export function Offer() {
  return <section className="py-16 px-4 bg-blue-900 text-white relative overflow-hidden" data-id="element-73">
      {/* Background pattern */}
      <div className="absolute inset-0 opacity-10 bg-[radial-gradient(circle_at_center,_var(--tw-gradient-stops))] from-white via-transparent to-transparent" data-id="element-74"></div>

      <div className="max-w-4xl mx-auto relative z-10 text-center" data-id="element-75">
        <div className="inline-block bg-red-600 text-white font-bold px-4 py-1 rounded-full text-sm mb-8 animate-pulse" data-id="element-76">
          ⏰ Oferta por tiempo limitado
        </div>

        <h2 className="text-3xl md:text-5xl font-bold mb-8" data-id="element-77">Accedé hoy a:</h2>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 max-w-2xl mx-auto mb-10 text-left" data-id="element-78">
          <div className="flex items-center gap-3 bg-white/10 p-3 rounded-lg" data-id="element-79">
            <Check className="text-green-400 w-6 h-6 flex-shrink-0" data-id="element-80" />
            <span className="font-semibold" data-id="element-81">
              6 tomos de Dormir Mejor Desde el Amor
            </span>
          </div>
          <div className="flex items-center gap-3 bg-white/10 p-3 rounded-lg" data-id="element-82">
            <Check className="text-green-400 w-6 h-6 flex-shrink-0" data-id="element-83" />
            <span className="font-semibold" data-id="element-84">3 bonos exclusivos</span>
          </div>
          <div className="flex items-center gap-3 bg-white/10 p-3 rounded-lg" data-id="element-85">
            <Check className="text-green-400 w-6 h-6 flex-shrink-0" data-id="element-86" />
            <span className="font-semibold" data-id="element-87">Acceso inmediato</span>
          </div>
          <div className="flex items-center gap-3 bg-white/10 p-3 rounded-lg" data-id="element-88">
            <Check className="text-green-400 w-6 h-6 flex-shrink-0" data-id="element-89" />
            <span className="font-semibold" data-id="element-90">Acompañamiento respetuoso</span>
          </div>
        </div>

        <div className="bg-white text-gray-900 rounded-2xl p-8 md:p-12 max-w-3xl mx-auto shadow-2xl transform hover:scale-[1.02] transition-transform duration-300" data-id="element-91">
          <div className="flex flex-col md:flex-row justify-center items-center gap-4 mb-6" data-id="element-92">
            <div className="text-gray-400 line-through text-xl" data-id="element-93">
              Precio regular: ARS $49.990
            </div>
            <div className="text-4xl md:text-5xl font-black text-red-600" data-id="element-94">
              🔥 HOY SOLO: ARS $19,990
            </div>
          </div>

          <div className="flex flex-wrap justify-center gap-4 text-sm font-medium text-gray-600 mb-8" data-id="element-95">
            <span className="flex items-center gap-1" data-id="element-96">
              <Check className="w-4 h-4 text-green-500" data-id="element-97" /> Acceso inmediato
            </span>
            <span className="flex items-center gap-1" data-id="element-98">
              <Check className="w-4 h-4 text-green-500" data-id="element-99" /> Un solo pago
            </span>
            <span className="flex items-center gap-1" data-id="element-100">
              <Check className="w-4 h-4 text-green-500" data-id="element-101" /> Descarga digital
            </span>
            <span className="flex items-center gap-1" data-id="element-102">
              <Check className="w-4 h-4 text-green-500" data-id="element-103" /> Acceso de por vida
            </span>
          </div>

          <Button href="https://checkout.mediosdigitalespro.online/cart/42525422551111:1" size="xl" fullWidth className="text-xl md:text-2xl shadow-xl animate-bounce" data-id="element-104">
            👉 OBTENER MI MEGAPACK HOY
          </Button>
        </div>
      </div>
    </section>;
}